const DataState = {
  LOADING: 'loading',
  ERROR: 'error',
  LOADED: 'loaded',
  INITIALIZED: 'initialized',
  SUCCESS: 'success',
};

export default DataState;
